import { ProgramTask } from '@cibo/core'
import { ModalProps } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useProgramEngagementContext } from '../../features/ProgramEngagement'
import { ENGAGEMENT_ROUTES, EngagementRouteParams } from '../../navigation/types/engagementRoutes'

export const useNavigateToNextTask = (
  setTaskDialogState?: Dispatch<
    SetStateAction<Pick<ModalProps, 'open'> & Pick<EngagementRouteParams, 'taskId'>>
  >
) => {
  const { engagementId, stageId = 'apply', stepId } = useParams<EngagementRouteParams>()
  const { basePath, program } = useProgramEngagementContext()
  const navigate = useNavigate()

  const navigateNext = (currentTaskId: ProgramTask['id']) => {
    //if the next task is hidden, show that task's content in a dialog
    const nextTaskId = program.data?.nextTaskId(currentTaskId)
    if (nextTaskId) {
      const nextTaskContent = program.data?.taskContent(nextTaskId)
      if (nextTaskContent?.hidden) {
        setTaskDialogState && setTaskDialogState({ open: true, taskId: nextTaskId })
      } else {
        //advance to the next task/step
        navigate(
          generatePath(`${basePath}${ENGAGEMENT_ROUTES.TASK}`, {
            engagementId,
            stageId,
            stepId,
            taskId: nextTaskId,
          })
        )
      }
    } else {
      //show the step status
      navigate(
        generatePath(`${basePath}${ENGAGEMENT_ROUTES.STEP_STATUS}`, {
          engagementId,
          stageId,
          stepId,
        })
      )
    }
  }
  return navigateNext
}
